import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { interval, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { CheckoutDialogComponent } from '../checkout-dialog/checkout-dialog.component';
import { UserProcessListDialogComponent } from '../user-process-list-dialog/user-process-list-dialog.component';
import { ProfessionalExperiencesComponent } from '../professional-experiences/professional-experiences.component';
import { SchoolingComponent } from '../schooling/schooling.component';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ValidTermosComponent } from '../valid-termos/valid-termos.component';
import { ProcessListViewDialogComponent } from '../process-list-view-dialog/process-list-view-dialog.component';
import { NotificationService } from 'src/services/notification.service';
import { OneSignalService } from 'src/services/onesignal.service';

@Component({
  selector: 'app-user-process-list',
  templateUrl: './user-process-list.component.html',
  styleUrls: ['./user-process-list.component.scss']
})
export class UserProcessListComponent implements OnInit {

  actions = {
    selected: null,
    viewed: null,
    searched: null
  }
  processLists: Array<any>;
  isMobile$: Observable<boolean>;
  user: any;
  processMode = 'default';
  checkView: boolean;

  constructor(
    private http: HttpService,
    private errorReport: ErrorReportService,
    private dialog: MatDialog,
    private breakpoints: BreakpointObserver,
    private router: Router,
    private snackbar: MatSnackBar,
    private notificationService: NotificationService,
    private oneSignalService: OneSignalService,

  ) { }

  ngOnInit(): void {

    this.isMobile$ = this.breakpoints
      .observe([Breakpoints.HandsetPortrait])
      .pipe(map(result => result.matches));

    this.user = JSON.parse(localStorage.getItem('token'));
    this.getProcessList();
    this.getProcessListAction();
    interval(10000).subscribe(() => {
      this.getProcessList()
      this.getProcessListAction();
    });

    this.verificaCad();

    if (localStorage.getItem('redirectProcessListId')) {
      const processListId = localStorage.getItem('redirectProcessListId');
      const leads = [{ id:this.user.id }];
      
      this.http.save('process_list:lead', { leads, processList: processListId, preApproval: true })
        .subscribe({
          next: ((result: any) => {
            if (result.type === 'OK') {
              this.snackbar.open('Você se inscreveu em um processo selectivo via link', 'OK', { duration: 3000 })

              const payload = { id: this.user.id }
              this.http.list('user_process_list', payload)
                .subscribe(
                  (result: any) => {
                    const [process] = result.data.slice(-1);
                    this.processLists = result.data;
                    this.openProcessList(process);
                    const foundProcess = this.processLists.find((process: any) => process.id === processListId);
                    const company_id = foundProcess.company;
                    const processname = foundProcess.name;

                    this.http.save('onsignal:getCompanySing', {id: company_id})
                      .subscribe(
                        (result: any) => {
                          if (result.type === 'OK') {
                            //console.log(result);
                            const signatureIds = [result.data[0].signature_id]; // Extrai os signature_ids
                            const notification_for_all = null;
                            const title = 'Novo Candidato';
                            const fullname = this.user.firstname+' '+this.user.lastname;
                            const message = this.oneSignalService.listMessage(1, fullname, processname );
                            
                            // Envia os dados para a função do backend que lida com as notificações
                            this.oneSignalService.sendNotification(signatureIds, title, message, notification_for_all)
                            .subscribe(
                              (result: any) => {
                                if (result.type === 'OK') {
                                  this.oneSignalService.listNotification();
                                } else {
                                  console.error('Erro ao enviar notificação sobre o processo seletivo');
                                }
                              },
                              err => {
                                console.error('Erro ao enviar notificação ao recrutador', err);
                                this.errorReport.showMessage(err);
                              }
                            );
                          } else {
                            console.error('Erro ao enviar notificação');
                          }
                        },
                        err => this.errorReport.showMessage(err)
                      )

                  },
                  err => this.errorReport.showMessage(err)
                )
              
            }
          }),
          error: (err: any) => this.errorReport.showMessage(err),
          complete: () => {
            localStorage.removeItem('redirectProcessListId')
          }
        })

    }

  }

  getProcessListAction() {

    const user: any = this.user;
    this.http.list('process_list_action', { id: user.id })
      .subscribe(
        (result: any) => {

          for (const action of result.data) {
            this.actions[action.action] = { ...action }
          }

        },
        err => this.errorReport.showMessage(err)
      )

  }

  getProcessList() {

    const user: any = this.user;
    this.http.list('user_process_list', { id: user.id })
      .subscribe(
        (result: any) => {
          // console.log('PROCESSLIST',result.data);
          this.processLists = result.data
          const hasViewProcessFalse = this.processLists.some((process: any) => process.viewprocess === 'false');
          if (hasViewProcessFalse) {
            this.checkView = false;
          } else {
            this.checkView = true;
          }
        },
        err => this.errorReport.showMessage(err)
      )

  }

  openViewProcessList() {

    const user: any = this.user;

    const options = {
      disableClose: true,
      width: '800px',
      data: {
        leadID: user.id
      }
    }
    this.dialog.open(ProcessListViewDialogComponent, options)
      .afterClosed()
      .subscribe(
        result => {
          if (result)
            this.getProcessList();
        }
      )
  }

  viewProcessList(event: Event, idLead: number, idProcess: number): void {

    event.stopPropagation();

    if (!confirm('Deseja realmente deixar de visualizar esse processo seletivo?'))
      return;

    this.http.save('process_list:view_update', { id: idLead, process_id: idProcess })
      .subscribe(
        (result: any) => {
          if (result.type === 'OK') {
            this.snackbar.open('Visualização do processo atualizado com sucesso!', 'OK', { duration: 3000 });
            this.getProcessList();
          }
        },
        err => this.errorReport.showMessage(err)
      )

  }

  openProcessList(processList) {

    // console.log('AQUII =====>',processList);
    // Verifica se o candidato ainda está no processo seletivo ou não 
    if(processList.candidateStatus == "disabled")
      return false;

    const user: any = this.user;
    const activeVoucher = localStorage.getItem('activeVoucher');
    const openPopup = () => {

      const options = {
        width: '800px',
        disableClose: true,
        data: processList
      };
      this.dialog.open(UserProcessListDialogComponent, options)
 
    }

    var plano = this.user.company_id ? 'BUSINESS' : 'PERSONAL';
    if (
      (processList.voucher !== (activeVoucher || user.voucher)) && user.signature_status !== 'ACTIVE' && this.user.signature_status !== 'TRIAL' && plano == 'BUSINESS'
    ) {

      this.notificationService.showAccountActivationMessage();
      

      // const options = {
      //   disableClose: true,
      //   width: '800px',
      //   data: {
      //     processListVoucher: processList.voucher,
      //     processListName: processList.name
      //   }
      // }
      // this.dialog.open(CheckoutDialogComponent, options)
      //   .afterClosed()
      //   .subscribe(
      //     result => {
      //       if (result)
      //         openPopup()
      //     }
      //   )
      return;
    }else{
      openPopup();
    }

  }

  verificaCad() {
    //Verificação do cadastro

    if (this.user) {
      if (!this.router.url.includes('/auth/login')) {
        if ((this.user.signature_plan_id == null || !this.user.signature_plan_id.includes('BUSINESS'))) {
          this.checktermos();
        }
      }
    }

  }

  experiences
  getProfessional() {

    const params = {
      id: this.user.id,
      all: true
    }
    this.http.get('experience', params)
      .subscribe(
        (result: any) => {

          this.experiences = result.data.slice(0, 3);
          if (this.experiences.length == 0) {
            if (this.user.first_job !== "true") {
              const dialogExperience = this.dialog.open(
                ProfessionalExperiencesComponent,
                {
                  width: '600px',
                  height: '600px',
                  disableClose: true,
                  data: {
                    message: 'Parece que você ainda não adicionou nenhuma experiência profissional ao seu perfil. Por favor, conclua o seu cadastro para que as empresas possam encontrar o seu currículo.'
                  }
                }
              );

              dialogExperience.afterClosed().subscribe(result => {
                this.getEducation();
              });

            }
          } else {
            this.getEducation();
          }

        },
        (err: any) => {
          console.error(err);
        }
      )


  }

  educations
  getEducation() {

    const params = {
      id: this.user.id,
      all: true
    }
    this.http.get('education', params)
      .subscribe(
        (result: any) => {

          this.educations = result.data.slice(0, 3);

          if (this.educations.length == 0) {
            this.dialog.open(
              SchoolingComponent,
              {
                width: '600px',
                height: '600px',
                disableClose: true,
                data: {
                  message: 'Parece que você ainda não cadastrou seus cursos. Por favor, conclua o seu cadastro para que as empresas possam encontrar o seu currículo.'
                }
              }
            );
          }

        },
        (err: any) => {
          console.error(err);
        }
      )

  }

  getPhoto() {

    if (this.user.avatar_profile === null) {
      const snackBarRef = this.snackbar.open(
        'Por favor insira uma foto no seu perfil, isso aumenta a chance de ser incluído(a) em um processo seletivo.',
        'Fechar',
        {
          // duration: 2000,
          panelClass: ['warning-snackbar'],
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });

      snackBarRef.afterDismissed().subscribe(info => {
        this.getProfessional();
      });

    } else {
      this.getProfessional();
    }

  }

  checktermos() {
    if (this.user.accept_term !== "true" || this.user.acceptContract !== "true") {
      const dialogTermos = this.dialog.open(
        ValidTermosComponent,
        {
          width: '600px',
          height: '600px',
          disableClose: true,
          data: {
            message: 'Parece que você ainda aceitou os termos de uso e/ou contrato. Por favor, confirme para continuar usando a Plataforma.'
          }
        }
      );

      dialogTermos.afterClosed().subscribe(result => {
        this.getPhoto();
      });


    } else {
      this.getPhoto();
    }
  }

  formatPhoneNumber(phoneNumber: string): string {
    if (!phoneNumber) {
      return '';
    }
  
    // Remove caracteres não numéricos
    phoneNumber = phoneNumber.replace(/\D/g, '');
  
    // Adiciona a máscara de telefone (exemplo: (99) 99999-9999)
    if (phoneNumber.length === 11) {
      return phoneNumber.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    } 
    
  }

  infoprocess(status:string){
    let mensagem = '';

    if(status=='process'){
      mensagem = 'Olá, você foi selecionado para a próxima fase, te desejamos uma boa sorte nessa nova etapa!';
    }
    if(status == 'finish'){
      mensagem = 'Olá, infelizmente você não foi selecionado para a próxima fase. Desejamos boa sorte nos próximos processos seletivos. Obrigado por participar!';
    }
    if(status == 'contratado'){
      mensagem = 'Parabéns! Você foi selecionado para fazer parte da equipe. Desejamos boa sorte nessa nova jornada. Seja bem-vindo(a)!'
    }

    this.snackbar.open(mensagem,'ok');
    return false;
  }


}